module.exports = __webpack_public_path__ + "static/media/FuturaPTMedium.bd99f124.otf";